module.exports = __webpack_public_path__ + "static/media/im12.f7ea5fb8.png";